import { RegionCode } from '@kaa/api/providers';
import { AvailableLanguages } from '@kaa/common/enums';
import { FooterWallonia } from '@kaa/core-app/common/components/wallonia/footer';
import {
  REGION_COMPLAINT_URL,
  REGION_CONDITIONS_URL,
  REGION_COOKIES_URL,
  REGION_NEWS_URL,
  REGION_PRIVACY_URL,
  REGION_QUESTION_URL,
} from '@kaa/core-app/providers/constants';
import { i18nKeys } from '@kaa/i18n/providers/keys';
import React from 'react';
import { useTranslation } from 'react-i18next';

type FooterProps = {
  regionCode: RegionCode;
  languages: AvailableLanguages[];
};

export const Footer = ({ regionCode }: FooterProps) => {
  const { t } = useTranslation();

  return (
    <FooterWallonia
      title={t(i18nKeys.footer.title)}
      subtitle={t(i18nKeys.footer.subtitle)}
      copyright={t(i18nKeys.footer.copyright)}
      url={t(i18nKeys.wl.brps.url)}
      foremLogoAlt={t(i18nKeys.footer.foremLogoAlt)}
      topLinks={[
        {
          url: t(REGION_QUESTION_URL[regionCode]),
          label: t(i18nKeys.footer.cta.question.label),
        },
        {
          url: t(REGION_COMPLAINT_URL[regionCode]),
          label: t(i18nKeys.footer.cta.complaint.label),
          modSecondary: true,
        },
      ]}
      bottomLinks={[
        {
          url: t(REGION_CONDITIONS_URL[regionCode]),
          label: t(i18nKeys.footer.nav.tc.label),
        },
        {
          url: t(REGION_PRIVACY_URL[regionCode]),
          label: t(i18nKeys.footer.nav.pp.label),
        },
        {
          url: t(REGION_COOKIES_URL[regionCode]),
          label: t(i18nKeys.footer.nav.cookies.label),
        },
        {
          url: t(REGION_NEWS_URL[regionCode]),
          label: t(i18nKeys.footer.nav.news.label),
        },
      ]}
    />
  );
};
